<template>       
    <div class="clearfix ">  
        <template v-if="mode == 0">
            <b-overlay :show="showoverlay" rounded="sm">
                <div class="clearfix mb-5"><ckeditor v-model="fdata.message"></ckeditor></div>

                <b-tabs pills  content-class="trz-wizard-content mt-4" nav-class="bg-white" nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav ml-auto pl-0">
                    <b-tab title="Maintenance Mode" active>
                        <b-form-group id="ip-group" label="Allowed IPs [comma seperated]" class="mt-4" label-for="ip">
                            <b-form-input id="ip" name="ip" v-model="fdata.ip"></b-form-input>
                        </b-form-group>

                        <b-button type="button" @click="save(0)" variant="success" >Down Now</b-button>

                    </b-tab>
                    <b-tab title="Email Maintenance Notice">
                        <b-form-group  id="subject-group" label="Subject" class="required-field" label-for="subject" >                                 
                            <b-form-input id="subject"  name="subject" v-model="fdata.subject"></b-form-input>                            
                        </b-form-group>
                        
                        
                        <b-form-group v-if="userlist"
                            label="User List"
                            v-slot="{ ariaDescribedby }"
                            >
                            
                        </b-form-group>

                        <b-button type="button" @click="save(1)" variant="success" >Send Notice</b-button>


                        <general-list  :checkbox="checkbox" :key="list_key"  :grid_options="grid_options" :grid_data="grid_data"  :default_column="default_column" :primary_key="primary_key"  v-on:childToParent="generalListReturn"></general-list>
            

                    </b-tab>
                </b-tabs>
            </b-overlay>
        </template>
        <template v-else-if="mode == 1">
            <b-button type="button" variant="success" @click="goUp()">Up</b-button>  
        </template>
    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        props: [],
        data(){            
            
            return {                
                
                fdata: {message:"Under maintanance" , ip: '' , flg:0 , userlist:null , subject:'accordHRM | System Maintenance Notice'}, 

                mode : null,
                show_userlist : false,

                userlist : [],
                selected_userlist : [],

                showoverlay:false,


                /**Child Component property data */
                selected: [],
                checkbox:1, 
                is_action:0,
                list_key:0, 
                grid_data : [],                
                default_column:['name','email','agent','company','user_level'], 
                primary_key:'id',
                grid_options:[],
                appended_column:[],
                /***Child Component property data */
                
            }
        },
        methods:{

            generalListReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                    console.log('selected');
                    console.log(this.selected);
                }
                else
                {
                    this.selected = [];
                    if(data.employee_id > 0)
                    {
                        //this.editEmployee(data.employee_id,0);

                        console.log(data[primary_key]);
                    }

                }
            },
            getUserList: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/maintenance/user/list' , {
                    params: {
                        
                    }
                }).then(function(response){
                    
                    this.grid_data = response.data.grid_data;
                    this.grid_options = response.data.options;
                    this.list_key = this.list_key + 1;

                }.bind(this)).catch(function (error){
                    currentObj.serverError(error);
                });
            },

            checkMode: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/maintenance/mode' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.mode = response.data;      
                    
                   

                }.bind(this)).catch(function (error){
                    currentObj.serverError(error);
                });
            },
            maintenanceModeText: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/maintenance/mode/text' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.fdata.message = response.data;                    

                }.bind(this)).catch(function (error){
                    currentObj.serverError(error);
                });
            },

            
            goUp: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                let formData = new FormData();

                axios.post(this.$api_url+'/site/up', formData)
                                .then(function (response) 
                                {                                    
                                    
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                
                                    this.checkMode();
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                });
            },

            save: function(f)
            {
                this.fdata.flg = f;
                this.fdata.userlist = this.selected;
                
                if(this.fdata.flg == 1)
                {
                    if(this.fdata.userlist.length == 0)
                    {
                         this.$bvToast.toast('Warning!', {
                                        title: `No Employee Selected`,
                                        variant: 'warning',
                                        solid: true
                                    });

                        return 0;
                    }
                } 
                this.showoverlay = true;
                let currentObj = this;                   
                let formData = new FormData();
    
                for (let [key, value] of Object.entries(this.fdata)) 
                {                    
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);                    
                    console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url+'/site/down', formData)
                .then(function (response) 
                {                                    
                    this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                    
                    this.showoverlay = false;
                
                    this.checkMode();
                    
                }.bind(this))
                .catch(function (error) 
                {                            
                    this.showoverlay = false;        
                    currentObj.serverError(error);
                });
            },
            
        },
        created: function(){
            this.checkMode();
            this.getUserList();
            this.maintenanceModeText();
        },        
    }
</script>
<style>
    .custom-checkbox{margin-top:10px;}
</style>